import React, { Component, Fragment } from 'react';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import {
  FooterFrame
} from '../../components';

import {
  // HTitle,
  CarouselWrapper
} from '../../components/HelperComponents/StyledComponents';

import {
  BulmaHero
} from '../../components/HelperComponents/HelperComponents';

import { fetchCarousel } from '../../actions/CarouselActions';

import {
  stripUrlQueryParams,
} from '../../helpers';


// const H2 = HTitle('h2');

class HomeCarouselComponent extends Component {

  static propTypes = {
    dispatch: PropTypes.any,
    newSongs: PropTypes.object,
    items: PropTypes.array
  };

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(fetchCarousel());
  }

  render() {
    if (!this.props.carousel.items && !this.props.isFetching) {
      return <p>{"Carousel's not working"}</p>
    }

    const allHeros = this.props.carousel.items.map((her, i) => (
      <div key={`carousel-item-${i}`}>
        {
          her.carousel_url && <a href={her.carousel_url}  target="_blank" rel="noopener">
            <BulmaHero key={"hero_" + i} heroSize="is-medium" activateBodyPadding={true} image={stripUrlQueryParams(her.carousel_image.url)}
              foot={<FooterFrame title={her.title.rendered} subtitle={her.subtitle} price={her.price} song={her.carousel_song[0]} />}>
            </BulmaHero>
          </a>
        }
        {
          !her.carousel_url && <BulmaHero key={"hero_" + i} heroSize="is-medium" activateBodyPadding={true} image={stripUrlQueryParams(her.carousel_image.url)}
            foot={<FooterFrame title={her.title.rendered} subtitle={her.subtitle} price={her.price} song={her.carousel_song[0]} />}>
          </BulmaHero>
        }
      </div>
    ));

    return (
      <Fragment>
        <section className="column is-11">
          {/*
            <H2 theme={{ fontSize: '24px', marginTop: 0, marginBottom: '20px' }}>New on Citizen</H2>
          */}

          <CarouselWrapper>
            <Slider autoplay={true} autoplaySpeed={5000}>
              {allHeros}
            </Slider>
          </CarouselWrapper>

        </section>
      </Fragment>
    );
  }
}

function mapStateToProps({ carousel }) {
  return {
    carousel
  }
}


export const HomeCarousel = connect(mapStateToProps)(HomeCarouselComponent);


// WEBPACK FOOTER //
// ./src/routes/Home/HomeComponent.js